$(document).ready(function () {
        $('.js-product-Look').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                infinite: false,
                responsive: [{
                        breakpoint: 1000,
                        settings: {
                                slidesToShow: 3,
                        }
                },
                        {
                                breakpoint: 600,
                                settings: {
                                        slidesToShow: 2
                                }
                        }]
        });
})